import styled, { css } from 'styled-components';
import { space } from 'styled-system';

import bg from '../assets/Prikut-bg-1.svg';
import bg2 from '../../components/LandingPage/Sections/Intro/assets/orng-circle.svg';
import arrowLeft from '../../assets/images/arrow_left.svg';
import arrowRight from '../../assets/images/arrow_right.svg';

import media from '../../utils/media';
import { baseH2 } from '../../components/Base';
import { buttonBasic } from '../../components/Buttons';

export const BlogPostWrapper = styled.div`
  ${space};
  width: 100%;
  font-size: 0.9em;
  padding-top: 0;

  p {
    margin: 0 0 10px 0;
    font-size: 14px;
  }

  h4 {
    margin-top: 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const MaxWidth = styled.div`
  max-width: ${(props) => 1024}px;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  padding: 0 32px;
`;

export const Thumbnail = styled.img`
  border-radius: 30px;

  height: 178px;

  object-fit: contain;

  ${media.tablet`
    height: 540px;
  `};

  ${media.laptop`
    height: 549px;
  `};
`;

export const ThumbnailWrapper = styled.div`
  padding-bottom: 30px;
`;

export const BlogPostHeader = styled.div`
  text-align: center;
  position: relative;

  position: relative;
  width: 100%;
  padding: 40px 0 0;

  ${(props) =>
    props.hideThumbnail
      ? ''
      : `
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          content: '';
          display: block;
          background-size: cover;
          background-image: url(${bg}), url(${bg2});
          background-color: #fcf1ed;
          background-repeat: no-repeat;

          background-position: left -20px bottom -100px, right -300px bottom -300px;
          background-size: contain,contain;
          border-bottom-left-radius: 40px;

          ${media.tablet`
            border-bottom-left-radius: 85px;
            margin-bottom: 200px;
          `};
        }
    `}
`;

export const BlogPostHeaderInner = styled.div`
  position: relative;
`;

export const H1 = styled.h1`
  ${baseH2};
  color: #592e2c;
  font-size: 2.55em;
  margin-top: 0;
`;

export const DateString = styled.div`
  color: rgba(164, 164, 164, 0.8);
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  margin-right: 15px;
`;

export const BgMask = styled.div`
  position: absolute;
  bottom: -250px;
  left: -100%;
  border-radius: 50%;
  border: 300px solid ${(props) => props.theme.colors.backgroundGrey};
  border-top-color: transparent;
  border-right-color: transparent;
  border-left-color: transparent;
  width: 300%;
  height: 135%;

  ${media.phone`height: 200%;`};
  ${media.tablet`height: 280%;`};
`;

export const BlogPostInner = styled.div`
  ${space};
  border-radius: 6px;
  position: relative;
  top: ${(props) => props.top || 0}px;
`;

export const User = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
`;

export const UserInfo = styled.div`
  text-align: left;
`;

export const PostMeta = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  margin-top: 25px;
`;

export const UserPic = styled.div`
  width: 55px;
  height: 55px;
  margin: 0 auto;
  padding: 3px;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.backgroundGrey};
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0px 2px #fed7c5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  img {
    max-width: 100%;
    object-fit: cover;
  }
`;

export const UserFullName = styled.div`
  font-size: 14px;
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 18px;
`;

export const UserName = styled.div`
  font-size: 14px;
  color: rgba(164, 164, 164, 0.8);
  letter-spacing: 0;
  line-height: 18px;
`;

export const Socials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SocialLink = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  margin-left: 25px;
  background-image: url(${(props) => props.$icon});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  opacity: 0.75;
  &:hover {
    transition: opacity 350ms;
    opacity: 1;
  }
`;

export const Body = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.94em;
  line-height: 30px;
  letter-spacing: 0.2px;

  img,
  video {
    max-width: 100%;
    display: block;
    margin: 0 auto;

    width: 311px;
    height: 178px;

    object-fit: contain;

    ${media.tablet`
      width: 590px;
      height: 337px;
    `};
  }

  a.image-link {
    img {
      width: auto;
      height: auto;
    }
  }

  a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .youtube-video {
    display: block;
    margin: 0 auto;

    ${media.tablet`
      width: 640px;
      height: 360px;
    `};
  }

  ul li p {
    margin: 0;
  }
`;

const baseLink = css`
  ${buttonBasic};
  width: 40px;
  height: 60px;
  border: none;
  padding: 0;
  background-size: 30px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  opacity: 0.3;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;

  &:hover {
    opacity: 0.5;
  }
`;

export const PrevLink = styled.button`
  ${baseLink};
  left: -5px;
  background-image: url(${arrowLeft});

  ${media.tablet`
    left: 10px;
  `};
`;

export const NextLink = styled.button`
  ${baseLink};
  right: -5px;
  background-image: url(${arrowRight});
  ${media.tablet`
    right: 10px;
  `};
`;
